
export function simpleFormData(form) {
  return Array.from(new FormData(form).entries()).map(([key, value]) =>
    `${encodeURIComponent(key)}=${encodeURIComponent(value)}`
  ).join('&');
}

export function mountCaptcha(captchaEl) {
  window.grecaptcha && window.grecaptcha.render(captchaEl, {
    sitekey: '6LdTshIUAAAAADdqSsgCAeRj5V-qQfB98Djqde6U'
  });
}

export function resetCaptcha() {
  window.grecaptcha && window.grecaptcha.reset();
}



// WEBPACK FOOTER //
// ./lib/util.js